import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import paramsValidator from '../../../utils/params-validator';
export default class ListRoute extends Route {
  queryParams = {
    search: { refreshModel: true },
    studentNumber: { refreshModel: true },
    groups: { refreshModel: true },
    certificability: { refreshModel: true },
    pageNumber: { refreshModel: true },
    pageSize: { refreshModel: true },
    participationCountOrder: { refreshModel: true },
    lastnameSort: { refreshModel: true },
    latestParticipationSort: { refreshModel: true },
  };

  @service currentUser;
  @service store;

  async model(params) {
    paramsValidator.validateCertificabilityParams(params);

    const organizationId = this.currentUser.organization.id;
    const participants = await this.store.query('sup-organization-participant', {
      filter: {
        organizationId,
        search: params.search,
        studentNumber: params.studentNumber,
        groups: params.groups,
        certificability: params.certificability,
      },
      sort: {
        participationCount: params.participationCountOrder,
        latestParticipationSort: params.latestParticipationSort,
        lastnameSort: params.lastnameSort,
      },
      page: {
        number: params.pageNumber,
        size: params.pageSize,
      },
    });

    const importDetail = this.currentUser.canAccessImportPage
      ? await this.store.queryRecord('organization-import-detail', {
          organizationId: this.currentUser.organization.id,
        })
      : null;

    return {
      importDetail,
      participants,
    };
  }

  resetController(controller, isExiting) {
    if (isExiting) {
      controller.search = null;
      controller.studentNumber = null;
      controller.groups = [];
      controller.certificability = [];
      controller.pageNumber = null;
      controller.pageSize = 50;
      controller.participationCountOrder = null;
      controller.latestParticipationSort = null;
      controller.lastnameSort = 'asc';
    }
  }

  @action
  refreshModel() {
    this.refresh();
  }
}
